import { z } from "zod";
import { IsoTimestamp, PlayerId } from "./ids.js";

// Supabase `players` row (KICKOFF §4.1). MSISDN is never stored raw — hash only.
export const Player = z.object({
  id: PlayerId,
  msisdn_hash: z.string().min(1),
  gamertag: z.string().min(2).max(24),
  badge_id: z.string().min(1), // COLOURS badge, e.g. "badge_b4_std" — BLG identity (FINAL WHISTLE ratification ① pending, built to BLG badge)
  avatar_id: z.string().min(1), // GAFFERS avatar, e.g. "av_g2_std"
  founder: z.boolean(),
  ea_gamertag: z.string().min(1),
  ea_friend_code: z.string().min(1).nullable(),
  division: z.number().int().min(1),
  confidence: z.number().int().min(0),
  coins: z.number().int().min(0),
  created_at: IsoTimestamp,
});
export type Player = z.infer<typeof Player>;
